import { ReactElement, forwardRef } from 'react';
import { Stack, StackProps, styled } from '@mui/material';

const StyledStack = styled(Stack)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(3),
    left: 0,
}));

export const PoolCardActionContainer = forwardRef<HTMLDivElement, StackProps>(
    (props: StackProps, ref): ReactElement => {
        return (
            <StyledStack ref={ref} {...props} gap={1} alignItems="flex-start">
                {props.children}
            </StyledStack>
        );
    }
);
